<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3" v-if="loaded">
      <b-col lg="12">
        <b-card title="Nouvel envoi" class="bg-light shadow" title-tag="h6">
          <b-row>
            <b-col lg="6">
              <b-card title="Expéditeur" class="bg-light shadow" title-tag="h6">
                <label>Adresse de l'expéditeur</label>
                <b-input disabled v-model="bootstrap.config[0]"></b-input>
                <label class="mt-2">Nom de l'expéditeur</label>
                <b-input v-model="bootstrap.config[2]"></b-input>
              </b-card>
              <b-card
                title="Destinataires"
                class="bg-light shadow mt-3"
                title-tag="h6"
                
              >
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    id="checkbox-group-2"
                    v-model="bootstrap.selected_groups"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-2"
                    stacked
                  >
                    <div class="d-flex justify-content-between"     v-for="(group, i) in bootstrap.groups" :key="i">
                      <b-form-checkbox
                        :value="group.ID"
                        >{{ group.nom }}</b-form-checkbox
                      >
                      <b-badge variant="success" class="my-1">{{group.count}}</b-badge>
                    </div>

                  </b-form-checkbox-group>
                </b-form-group>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card class="bg-light shadow" title="Mail" title-tag="h6">
                <label>Sujet</label>
                <b-input v-model="bootstrap.mail.subject"></b-input>
                <label class="mt-2">Contenu</label>
                <b-textarea ref="editor"
                  id="newsletter-editor"
                  rows="15"
                  style="width: 100%;"
                  v-model="bootstrap.mail.body">

                </b-textarea>
                
                <b-button @click="confirmSending()" :disabled="notValidated" class="mt-3" variant="success">Confirmer</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import newsletters from "@/services/newsletters.js";
//import { VueEditor } from "vue2-editor";
export default {
  name: "NewslettersNew",
  components: { },
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Module d'envoi de mails massif",
          to: { name: "newsletters" },
        },
        {
          text: "Nouvel envoi",
          active: true,
        },
      ],
      bootstrap: {},
      busy: false,
      loaded: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block"],
      ],
    };
  },
  computed: {
    notValidated() {
      if(this.bootstrap.mail.subject.trim() == '') {
        return true;
      }
      if(this.bootstrap.mail.body.trim() == '') {
        return true;
      }
      if(this.bootstrap.selected_groups.length == 0) {
        return true
      }
      return false;
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      newsletters.bootstrap().then((response) => {
        this.bootstrap = response.data;
        this.loaded = true;
      });
    },
    confirmSending() {
      newsletters.send(this.bootstrap).then((response) => {
        if(response.data.success) {
          this.$bvToast.toast("Newsletter en cours d'envoi", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.$router.push({name: 'newsletters'});
        } else {
           this.$bvToast.toast(response.data.message, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      })
    }
  },
};
</script>
<style lang="scss">
#newsletter-editor .ql-editor {
  min-height: 500px !important;
}
</style>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>